import { Component, OnInit, Input, inject, signal } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { Record } from 'src/app/models/record';
import { FavoritesItemButtonConfiguration } from 'src/app/models/buttons-config';
import { RecordRequest } from '../../../models/record-request';
import { Favorite } from 'src/app/state/user/favorites/models/favorites.response';
import { FavoritesFacade } from 'src/app/state/user/favorites/favorites.facade';

@Component({
  selector: 'app-user-favorite-item',
  templateUrl: './user-favorite-item.component.html',
  styleUrls: ['./user-favorite-item.component.scss'],
})
export class UserFavoriteItemComponent implements OnInit {
  private readonly apiService = inject(ApiService);
  private readonly favoriteFacade = inject(FavoritesFacade);

  readonly record = signal<Record | undefined>(undefined);

  @Input()
  favorite: Favorite;

  buttonConfig = new FavoritesItemButtonConfiguration();

  ngOnInit() {
    const request: RecordRequest = {
      recordIds: this.favorite.recordId,
      availability: true,
      faceted: false,
      lists: false,
    };

    this.apiService.getRecords(request).subscribe({
      next: (record) => this.record.set(record.records[0]),
      error: () => this.favoriteFacade.deleteFavorite(this.favorite.recordId)
    });
  }

  onItemRemoved() {
    this.favoriteFacade.deleteFavorite(this.favorite.recordId)
  }
}
